import { reduce } from 'lodash'

export const sourcesMap = {
	1: 'Zillow',
}

export default reduce(sourcesMap, (acc, source, key) => [...acc, {
	value: parseInt(key, 10),
	text: source,
}], [])
